import React, {
    useEffect,
    useRef,
    useState
} from 'react';

import Modal from 'react-modal';

import {
    ModalEconomiaContenido,
    ModalEconomiaCabecera,
    ModalEconomiaTitulo,
    ModalEconomiaSubtitulo,
    BotonCerrarModal,

    ModalSeccion,
    ModalSeccionTitulo,
    ModalAcciones,
    ModalScrollContenido,

    BotonPrincipal,
    BotonSecundario,

    CobroCampo,
    CobroLabel,
    CobroTextarea
} from '../../Css/StyledEstadisticasCobros.js';


Modal.setAppElement(
    '#root'
);


/*
====================================
DINERO
====================================
*/

const formatMoney = (
    value
) => {

    return new Intl.NumberFormat(
        'es-AR',
        {
            style:
                'currency',

            currency:
                'ARS',

            maximumFractionDigits:
                2
        }
    ).format(
        Number(
            value ||
            0
        )
    );

};


/*
====================================
FECHA
====================================
*/

const formatDate = (
    fecha
) => {

    if (
        !fecha
    ) {

        return '—';

    }


    const [
        year,
        month,
        day
    ] = String(
        fecha
    )
        .substring(
            0,
            10
        )
        .split('-');


    return `${day}/${month}/${year}`;

};


/*
====================================
MEDIO DE PAGO
====================================
*/

const getMedioPagoTexto = (
    medio
) => {

    switch (
        medio
    ) {

        case 'TRANSFERENCIA':

            return 'Transferencia';


        case 'EFECTIVO':

            return 'Efectivo';


        case 'MERCADO_PAGO':

            return 'Mercado Pago';


        case 'OTRO':

            return 'Otro';


        default:

            return medio || '—';

    }

};


/*
====================================
MODAL
====================================
*/

const HistorialPagosCentroModal = ({

    isOpen,

    onClose,

    centro,

    pagos,

    cargando,

    anulando,

    onAnular

}) => {


    /*
    ====================================
    ANULACIÓN
    ====================================
    */

    const [
        pagoAAnular,
        setPagoAAnular
    ] = useState(
        null
    );


    const [
        motivoAnulacion,
        setMotivoAnulacion
    ] = useState(
        ''
    );


    const [
        errorAnulacion,
        setErrorAnulacion
    ] = useState(
        ''
    );


    const [
        mensajeExito,
        setMensajeExito
    ] = useState(
        ''
    );


    /*
    ====================================
    SCROLL DEL HISTORIAL
    ====================================
    */

    const scrollHistorialRef =
        useRef(
            null
        );


    const [
        hayMasPagosAbajo,
        setHayMasPagosAbajo
    ] = useState(
        false
    );


    /*
    ====================================
    LIMPIAR AL CERRAR
    ====================================
    */

    useEffect(() => {

        if (
            !isOpen
        ) {

            setPagoAAnular(
                null
            );

            setMotivoAnulacion(
                ''
            );

            setErrorAnulacion(
                ''
            );

            setMensajeExito(
                ''
            );

            setHayMasPagosAbajo(
                false
            );

        }

    }, [
        isOpen
    ]);


    /*
    ====================================
    INDICADOR DE MÁS PAGOS
    ====================================
    */

    const actualizarIndicadorScroll = () => {

        const elemento =
            scrollHistorialRef
                .current;


        if (
            !elemento
        ) {

            setHayMasPagosAbajo(
                false
            );

            return;

        }


        const distanciaAlFinal =

            elemento.scrollHeight -
            elemento.scrollTop -
            elemento.clientHeight;


        setHayMasPagosAbajo(
            distanciaAlFinal >
                8
        );

    };


    /*
    ====================================
    ACTUALIZAR INDICADOR AL ABRIR
    ====================================
    */

    useEffect(() => {

        if (
            !isOpen
        ) {

            return;

        }


        const frame =
            requestAnimationFrame(
                () => {

                    const elemento =
                        scrollHistorialRef
                            .current;


                    if (
                        elemento
                    ) {

                        elemento.scrollTop =
                            0;

                    }


                    actualizarIndicadorScroll();

                }
            );


        const handleResize = () => {

            actualizarIndicadorScroll();

        };


        window.addEventListener(
            'resize',
            handleResize
        );


        return () => {

            cancelAnimationFrame(
                frame
            );


            window.removeEventListener(
                'resize',
                handleResize
            );

        };

    }, [
        isOpen,
        pagos,
        cargando
    ]);


    /*
    ====================================
    ABRIR ANULACIÓN
    ====================================
    */

    const handleAbrirAnulacion = (
        pago
    ) => {

        if (
            anulando
        ) {

            return;

        }


        setPagoAAnular(
            pago
        );


        setMotivoAnulacion(
            ''
        );


        setErrorAnulacion(
            ''
        );


        setMensajeExito(
            ''
        );

    };


    /*
    ====================================
    CERRAR ANULACIÓN
    ====================================
    */

    const handleCerrarAnulacion = () => {

        if (
            anulando
        ) {

            return;

        }


        setPagoAAnular(
            null
        );


        setMotivoAnulacion(
            ''
        );


        setErrorAnulacion(
            ''
        );

    };


    /*
    ====================================
    CONFIRMAR ANULACIÓN
    ====================================
    */

    const handleConfirmarAnulacion =
        async () => {

            setErrorAnulacion(
                ''
            );


            if (
                anulando
            ) {

                return;

            }


            const motivo =
                motivoAnulacion
                    .trim();


            if (
                !motivo
            ) {

                setErrorAnulacion(
                    'Indicá el motivo de la anulación.'
                );

                return;

            }


            if (
                typeof onAnular !==
                    'function' ||
                !pagoAAnular?.id
            ) {

                return;

            }


            const resultado =
                await onAnular({

                    pago_centro_id:
                        pagoAAnular.id,

                    motivo_anulacion:
                        motivo

                });


            if (
                resultado?.ok ===
                    false
            ) {

                setErrorAnulacion(
                    resultado.msg ||
                    'No se pudo anular el pago.'
                );

                return;

            }


            setPagoAAnular(
                null
            );


            setMotivoAnulacion(
                ''
            );


            setErrorAnulacion(
                ''
            );


            setMensajeExito(
                'El pago fue anulado correctamente.'
            );


            requestAnimationFrame(
                actualizarIndicadorScroll
            );

        };


    /*
    ====================================
    CERRAR PRINCIPAL
    ====================================
    */

    const handleCerrar = () => {

        if (
            anulando ||
            pagoAAnular
        ) {

            return;

        }


        onClose();

    };


    /*
    ====================================
    LISTADO
    ====================================
    */

    const listaPagos =
        Array.isArray(
            pagos
        )

            ? pagos

            : [];


    return (

        <>

            {/*
            ====================================
            HISTORIAL DE PAGOS
            ====================================
            */}

            <Modal

                isOpen={
                    isOpen
                }

                onRequestClose={
                    handleCerrar
                }

                shouldCloseOnOverlayClick={
                    !anulando &&
                    !pagoAAnular
                }

                shouldCloseOnEsc={
                    !anulando &&
                    !pagoAAnular
                }

                style={{

                    overlay: {

                        zIndex:
                            2000,

                        backgroundColor:
                            'rgba(0, 0, 0, 0.45)',

                        display:
                            'flex',

                        alignItems:
                            'center',

                        justifyContent:
                            'center',

                        padding:
                            '1rem'

                    },

                    content: {

                        position:
                            'relative',

                        inset:
                            'auto',

                        border:
                            'none',

                        background:
                            'transparent',

                        padding:
                            0,

                        width:
                            '96vw',

                        maxWidth:
                            '1250px',

                        maxHeight:
                            '92vh',

                        overflow:
                            'hidden'

                    }

                }}
            >

                {/*
                ====================================
                CONTENEDOR PRINCIPAL

                ModalEconomiaContenido tiene
                max-width: 650px globalmente.

                Acá lo anulamos solamente para
                este modal.
                ====================================
                */}

                <ModalEconomiaContenido

                    style={{

                        width:
                            '100%',

                        maxWidth:
                            'none',

                        height:
                            '88vh',

                        maxHeight:
                            '820px',

                        display:
                            'flex',

                        flexDirection:
                            'column',

                        overflow:
                            'hidden'

                    }}
                >


                    {/*
                    ====================================
                    CABECERA FIJA
                    ====================================
                    */}

                    <ModalEconomiaCabecera>

                        <div>

                            <ModalEconomiaTitulo>
                                Historial de pagos
                            </ModalEconomiaTitulo>


                            <ModalEconomiaSubtitulo>

                                {
                                    centro
                                        ?.nombre ||
                                    'Centro'
                                }

                            </ModalEconomiaSubtitulo>

                        </div>


                        <BotonCerrarModal

                            type="button"

                            onClick={
                                handleCerrar
                            }

                            disabled={
                                anulando
                            }
                        >
                            ×
                        </BotonCerrarModal>

                    </ModalEconomiaCabecera>


                    {/*
                    ====================================
                    ZONA SCROLLEABLE
                    ====================================
                    */}

                    <div
                        style={{

                            position:
                                'relative',

                            flex:
                                '1 1 auto',

                            minHeight:
                                0,

                            overflow:
                                'hidden'

                        }}
                    >

                        <ModalScrollContenido

                            ref={
                                scrollHistorialRef
                            }

                            onScroll={
                                actualizarIndicadorScroll
                            }

                            style={{

                                height:
                                    '100%',

                                maxHeight:
                                    'none',

                                overflowY:
                                    'auto',

                                overflowX:
                                    'hidden',

                                paddingRight:
                                    0,

                                paddingBottom:

                                    hayMasPagosAbajo

                                        ? '3.2rem'

                                        : '0.2rem'

                            }}
                        >


                            {/*
                            ====================================
                            MENSAJE DE ÉXITO
                            ====================================
                            */}

                            {
                                mensajeExito

                                    ? (

                                        <div
                                            style={{

                                                marginTop:
                                                    '1rem',

                                                marginBottom:
                                                    '0.4rem',

                                                padding:
                                                    '0.75rem 0.9rem',

                                                borderRadius:
                                                    '8px',

                                                backgroundColor:
                                                    '#F0F8F4',

                                                fontSize:
                                                    '0.78rem',

                                                fontWeight:
                                                    600

                                            }}
                                        >
                                            {
                                                mensajeExito
                                            }
                                        </div>

                                    )

                                    : null
                            }


                            <ModalSeccion>

                                <ModalSeccionTitulo>
                                    Pagos registrados
                                </ModalSeccionTitulo>


                                {
                                    cargando

                                        ? (

                                            <div
                                                style={{

                                                    padding:
                                                        '2rem',

                                                    textAlign:
                                                        'center',

                                                    fontSize:
                                                        '0.8rem'

                                                }}
                                            >
                                                Cargando pagos...
                                            </div>

                                        )

                                        : listaPagos.length ===
                                            0

                                            ? (

                                                <div
                                                    style={{

                                                        padding:
                                                            '2rem',

                                                        textAlign:
                                                            'center',

                                                        fontSize:
                                                            '0.8rem',

                                                        color:
                                                            '#6B7777'

                                                    }}
                                                >
                                                    No hay pagos registrados para este centro.
                                                </div>

                                            )

                                            : (

                                                <div
                                                    style={{

                                                        width:
                                                            '100%',

                                                        overflow:
                                                            'visible',

                                                        border:
                                                            '1px solid #E1E8E8',

                                                        borderRadius:
                                                            '10px'

                                                    }}
                                                >

                                                    <table
                                                        style={{

                                                            width:
                                                                '100%',

                                                            borderCollapse:
                                                                'collapse',

                                                            tableLayout:
                                                                'fixed',

                                                            fontSize:
                                                                '0.75rem'

                                                        }}
                                                    >

                                                        <colgroup>

                                                            <col
                                                                style={{
                                                                    width:
                                                                        '25%'
                                                                }}
                                                            />

                                                            <col
                                                                style={{
                                                                    width:
                                                                        '12%'
                                                                }}
                                                            />

                                                            <col
                                                                style={{
                                                                    width:
                                                                        '12%'
                                                                }}
                                                            />

                                                            <col
                                                                style={{
                                                                    width:
                                                                        '12%'
                                                                }}
                                                            />

                                                            <col
                                                                style={{
                                                                    width:
                                                                        '14%'
                                                                }}
                                                            />

                                                            <col
                                                                style={{
                                                                    width:
                                                                        '17%'
                                                                }}
                                                            />

                                                            <col
                                                                style={{
                                                                    width:
                                                                        '8%'
                                                                }}
                                                            />

                                                        </colgroup>


                                                        <thead>

                                                            <tr>

                                                                <th style={thStyle}>
                                                                    Fecha / detalle
                                                                </th>

                                                                <th style={thStyle}>
                                                                    Importe
                                                                </th>

                                                                <th style={thStyle}>
                                                                    Imputado
                                                                </th>

                                                                <th style={thStyle}>
                                                                    Disponible
                                                                </th>

                                                                <th style={thStyle}>
                                                                    Medio
                                                                </th>

                                                                <th style={thStyle}>
                                                                    Estado
                                                                </th>

                                                                <th style={thStyle}>
                                                                    Acción
                                                                </th>

                                                            </tr>

                                                        </thead>


                                                        <tbody>

                                                            {
                                                                listaPagos.map(
                                                                    (
                                                                        pago
                                                                    ) => {

                                                                        const anulado =

                                                                            pago
                                                                                ?.estado ===
                                                                            'ANULADO';


                                                                        return (

                                                                            <tr
                                                                                key={
                                                                                    pago.id
                                                                                }

                                                                                style={{

                                                                                    opacity:
                                                                                        anulado
                                                                                            ? 0.65
                                                                                            : 1,

                                                                                    borderTop:
                                                                                        '1px solid #E8EEEE'

                                                                                }}
                                                                            >

                                                                                {/*
                                                                                ====================================
                                                                                FECHA + DETALLE
                                                                                ====================================
                                                                                */}

                                                                                <td style={tdStyle}>

                                                                                    <strong>

                                                                                        {
                                                                                            formatDate(
                                                                                                pago.fecha_pago
                                                                                            )
                                                                                        }

                                                                                    </strong>


                                                                                    {
                                                                                        pago
                                                                                            ?.concepto

                                                                                            ? (

                                                                                                <div
                                                                                                    style={
                                                                                                        subTextoStyle
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        pago.concepto
                                                                                                    }
                                                                                                </div>

                                                                                            )

                                                                                            : null
                                                                                    }


                                                                                    {
                                                                                        pago
                                                                                            ?.referencia_externa

                                                                                            ? (

                                                                                                <div
                                                                                                    style={
                                                                                                        subTextoStyle
                                                                                                    }
                                                                                                >

                                                                                                    Ref.: {
                                                                                                        pago.referencia_externa
                                                                                                    }

                                                                                                </div>

                                                                                            )

                                                                                            : null
                                                                                    }

                                                                                </td>


                                                                                {/*
                                                                                ====================================
                                                                                IMPORTE
                                                                                ====================================
                                                                                */}

                                                                                <td style={tdStyle}>

                                                                                    <strong>

                                                                                        {
                                                                                            formatMoney(
                                                                                                pago.importe
                                                                                            )
                                                                                        }

                                                                                    </strong>

                                                                                </td>


                                                                                {/*
                                                                                ====================================
                                                                                IMPUTADO
                                                                                ====================================
                                                                                */}

                                                                                <td style={tdStyle}>

                                                                                    {
                                                                                        anulado

                                                                                            ? '—'

                                                                                            : formatMoney(
                                                                                                pago.importe_imputado
                                                                                            )
                                                                                    }

                                                                                </td>


                                                                                {/*
                                                                                ====================================
                                                                                DISPONIBLE
                                                                                ====================================
                                                                                */}

                                                                                <td style={tdStyle}>

                                                                                    {
                                                                                        anulado

                                                                                            ? '—'

                                                                                            : formatMoney(
                                                                                                pago.saldo_disponible
                                                                                            )
                                                                                    }

                                                                                </td>


                                                                                {/*
                                                                                ====================================
                                                                                MEDIO
                                                                                ====================================
                                                                                */}

                                                                                <td style={tdStyle}>

                                                                                    {
                                                                                        getMedioPagoTexto(
                                                                                            pago.medio_pago
                                                                                        )
                                                                                    }

                                                                                </td>


                                                                                {/*
                                                                                ====================================
                                                                                ESTADO
                                                                                ====================================
                                                                                */}

                                                                                <td style={tdStyle}>

                                                                                    <span
                                                                                        style={{

                                                                                            display:
                                                                                                'inline-block',

                                                                                            padding:
                                                                                                '0.2rem 0.45rem',

                                                                                            borderRadius:
                                                                                                '999px',

                                                                                            fontSize:
                                                                                                '0.65rem',

                                                                                            fontWeight:
                                                                                                700,

                                                                                            backgroundColor:

                                                                                                anulado

                                                                                                    ? '#FBEDEE'

                                                                                                    : '#EDF8F7',

                                                                                            color:

                                                                                                anulado

                                                                                                    ? '#B64D56'

                                                                                                    : '#087E80'

                                                                                        }}
                                                                                    >

                                                                                        {
                                                                                            anulado

                                                                                                ? 'Anulado'

                                                                                                : 'Registrado'
                                                                                        }

                                                                                    </span>


                                                                                    {
                                                                                        anulado &&
                                                                                        pago
                                                                                            ?.motivo_anulacion

                                                                                            ? (

                                                                                                <div
                                                                                                    style={{

                                                                                                        ...subTextoStyle,

                                                                                                        marginTop:
                                                                                                            '0.3rem',

                                                                                                        lineHeight:
                                                                                                            1.4

                                                                                                    }}
                                                                                                >
                                                                                                    {
                                                                                                        pago.motivo_anulacion
                                                                                                    }
                                                                                                </div>

                                                                                            )

                                                                                            : null
                                                                                    }

                                                                                </td>


                                                                                {/*
                                                                                ====================================
                                                                                ACCIÓN
                                                                                ====================================
                                                                                */}

                                                                                <td style={tdStyle}>

                                                                                    {
                                                                                        !anulado

                                                                                            ? (

                                                                                                <button

                                                                                                    type="button"

                                                                                                    onClick={() =>
                                                                                                        handleAbrirAnulacion(
                                                                                                            pago
                                                                                                        )
                                                                                                    }

                                                                                                    disabled={
                                                                                                        anulando
                                                                                                    }

                                                                                                    style={{

                                                                                                        border:
                                                                                                            'none',

                                                                                                        background:
                                                                                                            'transparent',

                                                                                                        padding:
                                                                                                            0,

                                                                                                        color:
                                                                                                            '#C44F58',

                                                                                                        fontSize:
                                                                                                            '0.7rem',

                                                                                                        fontWeight:
                                                                                                            700,

                                                                                                        cursor:

                                                                                                            anulando

                                                                                                                ? 'default'

                                                                                                                : 'pointer',

                                                                                                        textDecoration:
                                                                                                            'underline'

                                                                                                    }}
                                                                                                >
                                                                                                    Anular
                                                                                                </button>

                                                                                            )

                                                                                            : '—'
                                                                                    }

                                                                                </td>

                                                                            </tr>

                                                                        );

                                                                    }
                                                                )
                                                            }

                                                        </tbody>

                                                    </table>

                                                </div>

                                            )
                                }

                            </ModalSeccion>

                        </ModalScrollContenido>


                        {/*
                        ====================================
                        INDICADOR MÁS PAGOS
                        ====================================
                        */}

                        {
                            hayMasPagosAbajo &&
                            !cargando

                                ? (

                                    <div
                                        style={{

                                            position:
                                                'absolute',

                                            left:
                                                0,

                                            right:
                                                0,

                                            bottom:
                                                0,

                                            height:
                                                '3.5rem',

                                            display:
                                                'flex',

                                            alignItems:
                                                'flex-end',

                                            justifyContent:
                                                'center',

                                            paddingBottom:
                                                '0.65rem',

                                            boxSizing:
                                                'border-box',

                                            background:
                                                'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0.94) 52%, #FFFFFF 100%)',

                                            pointerEvents:
                                                'none',

                                            fontSize:
                                                '0.68rem',

                                            fontWeight:
                                                700,

                                            color:
                                                '#18898D'

                                        }}
                                    >
                                        Más pagos ↓
                                    </div>

                                )

                                : null
                        }

                    </div>

                </ModalEconomiaContenido>

            </Modal>


            {/*
            ====================================
            CONFIRMAR ANULACIÓN
            ====================================
            */}

            <Modal

                isOpen={
                    Boolean(
                        pagoAAnular
                    )
                }

                onRequestClose={
                    handleCerrarAnulacion
                }

                shouldCloseOnOverlayClick={
                    !anulando
                }

                shouldCloseOnEsc={
                    !anulando
                }

                style={{

                    overlay: {

                        zIndex:
                            2100,

                        backgroundColor:
                            'rgba(0, 0, 0, 0.45)',

                        display:
                            'flex',

                        alignItems:
                            'center',

                        justifyContent:
                            'center',

                        padding:
                            '1rem'

                    },

                    content: {

                        position:
                            'relative',

                        inset:
                            'auto',

                        border:
                            'none',

                        background:
                            'transparent',

                        padding:
                            0,

                        width:
                            '100%',

                        maxWidth:
                            '520px'

                    }

                }}
            >

                <ModalEconomiaContenido>


                    <ModalEconomiaCabecera>

                        <div>

                            <ModalEconomiaTitulo>
                                Anular pago
                            </ModalEconomiaTitulo>


                            <ModalEconomiaSubtitulo>

                                {
                                    pagoAAnular

                                        ? `${formatDate(
                                            pagoAAnular.fecha_pago
                                        )} · ${formatMoney(
                                            pagoAAnular.importe
                                        )}`

                                        : ''
                                }

                            </ModalEconomiaSubtitulo>

                        </div>


                        <BotonCerrarModal

                            type="button"

                            onClick={
                                handleCerrarAnulacion
                            }

                            disabled={
                                anulando
                            }
                        >
                            ×
                        </BotonCerrarModal>

                    </ModalEconomiaCabecera>


                    <ModalScrollContenido>


                        <ModalSeccion>

                            <div
                                style={{

                                    marginBottom:
                                        '1rem',

                                    fontSize:
                                        '0.8rem',

                                    lineHeight:
                                        1.5

                                }}
                            >
                                La anulación revertirá las imputaciones activas de este pago y conservará el registro histórico.
                            </div>


                            <CobroCampo>

                                <CobroLabel>
                                    Motivo de anulación *
                                </CobroLabel>


                                <CobroTextarea

                                    value={
                                        motivoAnulacion
                                    }

                                    onChange={(e) => {

                                        setMotivoAnulacion(
                                            e.target.value
                                        );


                                        setErrorAnulacion(
                                            ''
                                        );

                                    }}

                                    maxLength={
                                        500
                                    }

                                    placeholder="Ej.: Pago cargado por error"

                                    disabled={
                                        anulando
                                    }
                                />

                            </CobroCampo>


                            {
                                errorAnulacion

                                    ? (

                                        <div
                                            style={{

                                                marginTop:
                                                    '0.75rem',

                                                color:
                                                    '#C44F58',

                                                fontSize:
                                                    '0.75rem',

                                                fontWeight:
                                                    600

                                            }}
                                        >
                                            {
                                                errorAnulacion
                                            }
                                        </div>

                                    )

                                    : null
                            }

                        </ModalSeccion>


                        <ModalAcciones>

                            <BotonSecundario

                                type="button"

                                onClick={
                                    handleCerrarAnulacion
                                }

                                disabled={
                                    anulando
                                }
                            >
                                Cancelar
                            </BotonSecundario>


                            <BotonPrincipal

                                type="button"

                                onClick={
                                    handleConfirmarAnulacion
                                }

                                disabled={
                                    anulando
                                }
                            >

                                {
                                    anulando

                                        ? 'Anulando...'

                                        : 'Anular pago'
                                }

                            </BotonPrincipal>

                        </ModalAcciones>

                    </ModalScrollContenido>

                </ModalEconomiaContenido>

            </Modal>

        </>

    );

};


/*
====================================
ESTILOS TABLA
====================================
*/

const thStyle = {

    textAlign:
        'left',

    padding:
        '0.7rem 0.75rem',

    fontSize:
        '0.62rem',

    textTransform:
        'uppercase',

    color:
        '#697777',

    whiteSpace:
        'nowrap',

    verticalAlign:
        'bottom',

    position:
        'sticky',

    top:
        0,

    zIndex:
        1,

    backgroundColor:
        '#F7FAFA'

};


const tdStyle = {

    padding:
        '0.8rem 0.75rem',

    verticalAlign:
        'top',

    overflowWrap:
        'anywhere'

};


const subTextoStyle = {

    marginTop:
        '0.2rem',

    fontSize:
        '0.65rem',

    color:
        '#728080',

    lineHeight:
        1.35

};


export default HistorialPagosCentroModal;